<template>
  <div class="w-full" v-if="outlet">
    <div class="outlet rounded px-2 pt-2 pb-8 mb-6">
      <el-row :gutter="20">
        <el-col :span="24" class="mb-6">
          <el-button icon="el-icon-back" size="small"
                     @click="$router.push('/ecommerce/outlets')">Back to list</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" class="float-right"
                     @click="onDeleteOutlet(outlet.id)">Delete</el-button>
          <el-button type="warning" icon="el-icon-edit" size="small" class="float-right"
                     @click="onEditOutlet(outlet)">Edit</el-button>
          <el-button class="float-right" type="primary" icon="el-icon-plus" size="small"
                     @click="openNewOutletDialog">New</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Name:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">{{ outlet.name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Unique Code/Identifier:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">{{ outlet.p_code }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Address:</div></el-col>
        <el-col :span="14"><div class="px-4 mb-6">
          {{ outlet.address }}
          <span v-if="outlet.city"> {{ outlet.city }},</span>
          <span v-if="outlet.postal_code"> {{ outlet.postal_code }}</span>
          <span v-if="outlet.state"> {{ outlet.state.name }},</span>
          <span v-if="outlet.country"> {{ outlet.country.name }}</span>
        </div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Enabled:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">
            <template v-if="outlet.status === true"><el-tag size="small" type="success">Yes</el-tag></template>
            <template v-else><el-tag size="small" type="danger">No</el-tag></template>
          </div>
        </el-col>
      </el-row><br>
      <hr><br>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Total Items:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">
            <span v-if="outlet.item_count > 0"><el-tag size="small" type="info">{{ outlet.item_count }}</el-tag></span>
            <span v-else><el-tag size="small" type="info">0</el-tag></span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Total Orders:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">
            <span v-if="outlet.order_count > 0"><el-tag size="small" type="info">{{ outlet.order_count }}</el-tag></span>
            <span v-else><el-tag size="small" type="info">0</el-tag></span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Order Gross Total:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">
            <span v-if="outlet.total_order_amount > 0"><el-tag size="small" type="info">{{ outlet.total_order_amount }}</el-tag></span>
            <span v-else><el-tag size="small" type="info">0</el-tag></span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="outlet.image">
        <el-col>
          <div class="px-4 mb-6">
            <img :src="outlet.image" class="image"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <OutletUpdateForm :upload_url="upload_url" />
    <NewOutletForm />
  </div>
</template>

<script>

import NewOutletForm from './_includes/NewOutletForm.vue';
import OutletUpdateForm from './_includes/OutletUpdateForm.vue';

export default {
  name: 'OutletDetails',
  data() {
    return {
      updating: false,
      upload_url: null,
    };
  },
  components: {
    OutletUpdateForm,
    NewOutletForm,
  },
  computed: {
    outlet() {
      return this.$store.state.OutletModule.outlet;
    },
  },
  methods: {
    openNewOutletDialog() {
      this.$modal.show('new-outlet-modal');
    },
    onEditOutlet(outlet) {
      this.upload_url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${outlet.id}/images?type=outlets`;
      this.$store.commit('OutletModule/setProperty', { property: 'outlet', payload: outlet });
      this.$modal.show('update-outlet-modal');
    },
    onDeleteOutlet(outletId) {
      this.$confirm('Are you sure you want to delete this outlet?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OutletModule/deleteOutlet', { outletId });
          this.$notify.success({
            title: 'Success',
            message: 'Outlet has been deleted.',
          });
          await this.$router.push('/ecommerce/outlets');
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    async updateCoordinates() {
      this.updating = true;
      let address = null;
      if (this.outlet.postal_code) {
        address = `${this.outlet.address}+${this.outlet.city.name}+${
          this.outlet.postal_code}+${this.outlet.state.name}+${this.outlet.country.name}`;
      } else {
        address = `${this.outlet.address}+${this.outlet.city.name}+${
          this.outlet.state.name}+${this.outlet.country.name}`;
      }
      try {
        await this.$store.dispatch('OutletModule/getOutletCoordinate', { address });
        this.$notify.success({
          title: 'Success',
          message: 'Outlet coordinate update was successful.',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.updating = false;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('OutletModule/getOutlet', { outletId: this.$route.params.id });
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>
  .image {
    object-fit: contain;
    width: 250px;
    height: 250px;
  }
</style>
